/*------------------------------------------------------------------
Please read!
------------------------------------------------------------------*/

/*
This file is a symlink to the blocks.js file in the app folder,
making changes here affects subsites that are using the blocks.js
*/

/*------------------------------------------------------------------
Import the block scripts
------------------------------------------------------------------*/

// Store the imported scripts using a Set for uniqueness and faster lookups
const imported = new Set();
// Get the context of the blocks folder
const context = require.context('./blocks', true, /\.js$/);
// List the required blocks and their paths, they will be imported on demand when the block is added to the page
const blocks = {
  '.js-default-pdf': './default/pdf',
  '.js-default-accordion': './default/accordion',
  '.js-default-appointment': './default/appointment',
  '.js-default-slider': './default/slider',
  '.js-default-gallery': './default/gallery',
  '.js-default-testimonial': './default/testimonial',
  '.js-default-team': './default/team',
  '.js-default-number': './default/number',
  '.js-rounded-media-text': './rounded/media-text',
  '.js-default-logo': './default/logo',
  '.js-default-logo-grid': './default/logo-grid',
  '.js-block-testimonial': './block/testimonial'
  // '.js-flow-timeline': './flow/timeline',
};

// Function to import a block script
function importBlock(selector, path) {
  if (imported.has(path)) return;
  imported.add(path);
  try {
    context(`${path}.js`);
  } catch (error) {
    console.warn('Error importing block: ', selector);
    console.error(error);
  }
}

// Initialize block watchers
function initBlockWatchers() {
  console.log("%cblocks", "color:#0c0c0d; font-family: monospace; font-size: 20px; padding: 5px 10px; border-radius: 5px; background-color: #f7ebde");
  Object.entries(blocks).forEach(_ref => {
    let [selector, path] = _ref;
    DomObserver.observe(selector, () => importBlock(selector, path));
  });
}

// Initialize the block watchers when the document is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initBlockWatchers);
} else {
  initBlockWatchers();
}

// Add the src and a condition required to load the script
// document.addEventListener('DOMContentLoaded', () => {
//   window.BlocksLoaded = ScriptLoader({
//     './blocks/default/accordion': document.querySelector('.js-default-accordion'),
//     './blocks/default/slider': document.querySelector('.js-default-slider'),
//     './blocks/default/gallery': document.querySelector('.js-default-gallery'),
//     './blocks/default/testimonial': document.querySelector('.js-default-testimonial'),
//     './blocks/default/team': document.querySelector('.js-default-team'),
//     './blocks/default/number': document.querySelector('.js-default-number'),
//     './blocks/rounded/media-text': document.querySelector('.js-rounded-media-text'),
//   }, 'blocks-loaded');
// });

/*------------------------------------------------------------------
Document Setup
------------------------------------------------------------------*/

// console.log("%cblocks", "color:#0c0c0d; font-family: monospace; font-size: 20px; padding: 5px 10px; border-radius: 5px; background-color: #f7ebde");
// document.body.classList.add('blocks-loaded');